import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {CrimeDocProgress} from './crime-doc-progress.js';

/**
 * inventory
 */
export class Inventory extends Component {
    static TypeName = 'inventory';
    /* Properties that are configurable in the editor */
    @property.object()
    levelManager?: Object3D;

    @property.object({required: true})
    crimedocProgressObject!: Object3D;

    #crimeDocNum = 0;
    get crimeDocNum() {
        return this.#crimeDocNum;
    }
    set crimeDocNum(value) {
        this.#crimeDocNum = value;
        this.crimedocProgressObject.getComponent(CrimeDocProgress)?.updateNumber(value);
    }

    crimeDoc1 = false;
    crimeDoc2 = false;
    crimeDoc3 = false;
    stringsActiveNum = 0;

    start() {
        /* Inventory Colletion */
        this.crimeDocNum = 0;
        this.crimeDoc1 = false;
        this.crimeDoc2 = false;
        this.crimeDoc3 = false;

        /* MuderImage Strings */
        this.stringsActiveNum = 0;
    }
}
